export const DrugKeys = {
    ZepboundVial: 'ZepboundVial',
    ZepboundAutoinjector: 'ZepboundAutoinjector',
    ZepboundKwikPen: 'ZepboundKwikPen',
    Orfo: 'Foundayo',
    Emgality: 'Emgality',
    Mounjaro: 'Mounjaro',
    Trulicity: 'Trulicity',
} as const;

export type DrugKey = keyof typeof DrugKeys;

export type DrugKeyType = (typeof DrugKeys)[DrugKey];
